
<template>
 
            <v-btn class="ma-2" outlined color="teal" @click="login()">Dashboard</v-btn>
  
</template>


<script>

export default {
  name: "login",
  methods: {
    login() {
      this.$router.push({ name: "hr" });
    }
  }
};
</script>

<style>
.ml-20 {
  margin-left: 20px;
}
.logo {
  width: 300px;
}
.left-side-board {
  text-align: center;
  margin: 50px auto;
}
.voice {
  width: 370px;
  margin-top: 30px;
}
h1 {
  color: #78b59c;
}
.form-margin {
  margin-top: 10%;
}
@media only screen and (max-width: 768px) {
  /* For mobile phones: */
  .form-margin {
    margin-top: 0px !important;
  }
  .voice {
    width: 260px;
    margin-top: 10px;
  }
  .logo {
    width: 230px;
  }
}
</style>


